import AudioPreviewState from './store/schema/AudioPreviewState';
import IframePreviewState from './store/schema/IFramePreviewState';
import ImageGalleryItem from './store/schema/ImageGalleryItem';
import ImagePreviewState from './store/schema/ImagePreviewState';
import NativePdfPreviewState from './store/schema/NativePdfPreviewState';
import PdfJsPreviewState, { PdfJsPasswordState } from './store/schema/PdfJsPreviewState';
import PreviewPaneViewState, {
    PreviewPaneCustomViewState,
    PreviewPaneErrorViewState,
    PreviewPaneLoadingViewState,
    PreviewPaneMode,
    PreviewPaneViewStateBase,
} from './store/schema/PreviewPaneViewState';
import SxSViewState, { RightPaneDisplay } from './store/schema/SxSViewState';
import TextPreviewState from './store/schema/TextPreviewState';
import VideoPreviewState from './store/schema/VideoPreviewState';
import WacPreviewState from './store/schema/WacPreviewState';
import { LazyImport, LazyModule } from 'owa-bundling';
import {
    MIN_PREVIEW_PANE_WIDTH,
    MIN_READING_PANE_WIDTH,
    MIN_SXS_WIDTH,
    PREVIEW_PANE_WIDTH,
    READING_PANE_DEFAULT_PERCENT_SIZE,
    READING_PANE_WIDTH,
    RESPONSIVE_READING_PANE_WIDTH,
} from './utils/sxsConstants';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "SxS" */ './lazyIndex'));

export const lazySxSDataModule = new LazyImport(lazyModule, m => m);
export const lazyResetPreviewPane = new LazyImport(lazyModule, m => m.resetPreviewPane);
export const lazySetAudioPreviewState = new LazyImport(lazyModule, m => m.setAudioPreviewState);
export const lazySetBlankPreviewState = new LazyImport(lazyModule, m => m.setBlankPreviewState);
export const lazySetCustomPreviewState = new LazyImport(lazyModule, m => m.setCustomPreviewState);
export const lazySetIframePreviewState = new LazyImport(lazyModule, m => m.setIframePreviewState);
export const lazySetImageGalleryItems = new LazyImport(lazyModule, m => m.setImageGalleryItems);
export const lazySetImagePreviewLoaded = new LazyImport(lazyModule, m => m.setImagePreviewLoaded);
export const lazySetImagePreviewState = new LazyImport(lazyModule, m => m.setImagePreviewState);
export const lazySetImagePreviewStateFromImageGalleryItem = new LazyImport(
    lazyModule,
    m => m.setImagePreviewStateFromImageGalleryItem
);
export const lazySetNativePdfPreviewState = new LazyImport(
    lazyModule,
    m => m.setNativePdfPreviewState
);
export const lazySetPanesSize = new LazyImport(lazyModule, m => m.setPanesSize);
export const lazySetPdfJsPreviewState = new LazyImport(lazyModule, m => m.setPdfJsPreviewState);
export const lazySetPdfJsPreviewStateByData = new LazyImport(
    lazyModule,
    m => m.setPdfJsPreviewStateByData
);
export const lazySetPreviewError = new LazyImport(lazyModule, m => m.setPreviewError);
export const lazySetPreviewLoading = new LazyImport(lazyModule, m => m.setPreviewLoading);
export const lazySetRightPaneDisplayAndUpdateSize = new LazyImport(
    lazyModule,
    m => m.setRightPaneDisplayAndUpdateSize
);
export const lazySetTextPreviewState = new LazyImport(lazyModule, m => m.setTextPreviewState);
export const lazySetVideoPreviewState = new LazyImport(lazyModule, m => m.setVideoPreviewState);
export const lazySetWacPreviewState = new LazyImport(lazyModule, m => m.setWacPreviewState);
export const lazyUpdatePanesSize = new LazyImport(lazyModule, m => m.updatePanesSize);

export {
    AudioPreviewState,
    IframePreviewState,
    ImageGalleryItem,
    ImagePreviewState,
    NativePdfPreviewState,
    PdfJsPasswordState,
    PdfJsPreviewState,
    PreviewPaneCustomViewState,
    PreviewPaneErrorViewState,
    PreviewPaneLoadingViewState,
    PreviewPaneMode,
    PreviewPaneViewState,
    PreviewPaneViewStateBase,
    RightPaneDisplay,
    SxSViewState,
    TextPreviewState,
    VideoPreviewState,
    WacPreviewState,
};
export {
    MIN_PREVIEW_PANE_WIDTH,
    MIN_READING_PANE_WIDTH,
    MIN_SXS_WIDTH,
    PREVIEW_PANE_WIDTH,
    READING_PANE_DEFAULT_PERCENT_SIZE,
    READING_PANE_WIDTH,
    RESPONSIVE_READING_PANE_WIDTH,
};
